// Icônes au trait (charte D-038) : SVG en ligne, trait de la couleur courante, jamais d'emoji.

import type { ReactElement } from 'react';

export type NomIcone =
  | 'accueil'
  | 'formulaire'
  | 'camion'
  | 'message'
  | 'plus'
  | 'controle'
  | 'cuve'
  | 'liste'
  | 'document'
  | 'soleil'
  | 'lune'
  | 'aide'
  | 'sortie'
  | 'retour'
  | 'chevron'
  | 'incident'
  | 'ajout'
  | 'reseau'
  // Messagerie et notifications (H2), versées depuis modules/messagerie/icones.tsx à l'intégration.
  | 'cloche'
  | 'trombone'
  | 'envoyer'
  | 'cadenas'
  | 'recherche'
  | 'citation'
  | 'groupe'
  | 'annonce'
  | 'crise'
  | 'personne';

const TRACES: Record<NomIcone, ReactElement> = {
  accueil: <path d="M3 11l9-7 9 7v9H3z" />,
  formulaire: (
    <>
      <rect x="5" y="3" width="14" height="18" rx="2" />
      <path d="M9 8h6M9 12h6M9 16h3" />
    </>
  ),
  camion: (
    <>
      <path d="M3 7h11v9H3zM14 10h4l3 3v3h-7" />
      <circle cx="7" cy="18" r="2" />
      <circle cx="17" cy="18" r="2" />
    </>
  ),
  message: <path d="M4 5h16v11H8l-4 4z" />,
  plus: (
    <>
      <circle cx="5" cy="12" r="1.5" />
      <circle cx="12" cy="12" r="1.5" />
      <circle cx="19" cy="12" r="1.5" />
    </>
  ),
  controle: (
    <>
      <path d="M9 11l3 3 7-7" />
      <path d="M20 12v6a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h9" />
    </>
  ),
  cuve: (
    <>
      <rect x="6" y="3" width="12" height="18" rx="3" />
      <path d="M6 13h12" />
    </>
  ),
  liste: <path d="M4 6h16M4 12h16M4 18h10" />,
  document: (
    <>
      <path d="M6 3h9l4 4v14H6z" />
      <path d="M15 3v4h4" />
    </>
  ),
  soleil: (
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
    </>
  ),
  lune: <path d="M21 13A9 9 0 1111 3a7 7 0 0010 10z" />,
  aide: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.5 9.5a2.5 2.5 0 015 0c0 1.5-2.5 2-2.5 3.5M12 17v.5" />
    </>
  ),
  sortie: (
    <>
      <path d="M10 4H5v16h5" />
      <path d="M14 8l4 4-4 4M18 12H9" />
    </>
  ),
  retour: <path d="M15 6l-6 6 6 6" />,
  chevron: <path d="M9 6l6 6-6 6" />,
  incident: (
    <>
      <path d="M12 3l9 16H3z" />
      <path d="M12 10v4M12 17v.5" />
    </>
  ),
  ajout: <path d="M12 5v14M5 12h14" />,
  reseau: (
    <>
      <circle cx="5" cy="6" r="2" />
      <circle cx="19" cy="6" r="2" />
      <circle cx="12" cy="18" r="2" />
      <path d="M6.5 7.5L11 16M17.5 7.5L13 16" />
    </>
  ),
  cloche: (
    <>
      <path d="M6 16V11a6 6 0 0112 0v5l2 2H4z" />
      <path d="M10 20a2 2 0 004 0" />
    </>
  ),
  trombone: (
    <path d="M20 11.5l-7.8 7.8a5 5 0 01-7.1-7.1l8.5-8.5a3.3 3.3 0 014.7 4.7l-8.5 8.5a1.7 1.7 0 01-2.4-2.4L15 6.9" />
  ),
  envoyer: <path d="M4 12l16-8-6 16-3-7z" />,
  cadenas: (
    <>
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V8a4 4 0 018 0v3" />
    </>
  ),
  recherche: (
    <>
      <circle cx="11" cy="11" r="6" />
      <path d="M20 20l-4.5-4.5" />
    </>
  ),
  citation: <path d="M5 7h5v5c0 3-2 5-5 6M14 7h5v5c0 3-2 5-5 6" />,
  groupe: (
    <>
      <circle cx="9" cy="8" r="3" />
      <path d="M3 20a6 6 0 0112 0" />
      <path d="M16 5a3 3 0 010 6M17 14a6 6 0 014 6" />
    </>
  ),
  annonce: (
    <>
      <path d="M4 10v4h3l7 4V6L7 10z" />
      <path d="M18 9a4 4 0 010 6" />
    </>
  ),
  crise: (
    <>
      <path d="M12 3l9 16H3z" />
      <path d="M12 10v4M12 17v.5" />
    </>
  ),
  personne: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21a8 8 0 0116 0" />
    </>
  ),
};

export function Icone({ nom, taille = 18, epaisseur = 2 }: { nom: NomIcone; taille?: number; epaisseur?: number }) {
  return (
    <svg aria-hidden="true" width={taille} height={taille} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={epaisseur} strokeLinecap="round" strokeLinejoin="round">
      {TRACES[nom]}
    </svg>
  );
}
